import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { generarEscritoAmparoPncDesdeDatos, generarEscritoAmparoPncTramite } from '../../services/amparoPncEscritoService';
import ModalGenerarAmparoPnc from './ModalGenerarAmparoPnc';

function descargarBlob(data, nombreArchivo) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

/**
 * Botón "Generar Escrito de Amparo" — molde: BotonGenerarCaratulaAmparoPnc. Dos modos, según
 * qué prop llega:
 *  - `idTramite` (ficha): el trámite ya existe, se genera desde la entidad guardada y además
 *    queda adjuntado a sus Archivos.
 *  - `datos` sin `idTramite` (alta): el trámite todavía no existe, se genera solo con lo que
 *    ya se tipeó en el formulario (sin persistir nada).
 *
 * A diferencia de la carátula, acá no hay paso de prefill editable: el modal solo confirma qué
 * plantilla corresponde (ver resolverPlantillaAmparo) y avisa de los blancos a completar a
 * mano, no deja tocar los datos.
 */
export default function BotonGenerarAmparoPnc({ idTramite, datos, onGenerado }) {
    const [modalAbierto, setModalAbierto] = useState(false);
    const [generando, setGenerando] = useState(false);

    const esFicha = !!idTramite;
    const tieneClienteSeleccionado = esFicha || !!(datos && datos.cuil);

    if (!tieneClienteSeleccionado && !esFicha) {
        return (
            <button type="button" className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill" disabled>
                <i className="bi bi-file-earmark-richtext"></i>
                Generar Escrito de Amparo
            </button>
        );
    }

    const handleConfirmar = async () => {
        setGenerando(true);
        try {
            const response = esFicha
                ? await generarEscritoAmparoPncTramite(idTramite)
                : await generarEscritoAmparoPncDesdeDatos(datos);

            const nombreArchivo = `AMPARO PNC - ${datos?.cuil || idTramite}.docx`;
            descargarBlob(response.data, nombreArchivo);
            toast.success('Descargando el escrito de Amparo PNC');
            setModalAbierto(false);
            if (onGenerado) onGenerado();
        } catch (err) {
            console.error('❌ Error generando el escrito de Amparo PNC:', err);
            toast.error('No se pudo generar el escrito de Amparo PNC');
        } finally {
            setGenerando(false);
        }
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill"
                onClick={() => setModalAbierto(true)}
            >
                <i className="bi bi-file-earmark-richtext"></i>
                Generar Escrito de Amparo
            </button>
            <ModalGenerarAmparoPnc
                abierto={modalAbierto}
                generando={generando}
                datos={datos}
                onCancelar={() => setModalAbierto(false)}
                onConfirmar={handleConfirmar}
            />
        </>
    );
}
